<template>
  <v-navigation-drawer
    app
    clipped
    v-model="DRAWER_STATE"
    :mini-variant="!DRAWER_STATE"
    :width="sidebarWidth"
    :permanent="$vuetify.breakpoint.lgAndUp"
    :temporary="$vuetify.breakpoint.mdAndDown"
    :mini-variant-width="sidebarMinWidth"
    :class="{'drawer-mini': !DRAWER_STATE}"
  >
    <v-list>
      <template v-for="item in sections">
        <v-list-group
          color="primary"
          v-if="item.children && DRAWER_STATE"
          :key="item.title"
          v-model="item.model"
        >
          <template v-slot:prependIcon>
            <v-icon size="24" class="mr-0"> {{ item.icon }} </v-icon>
          </template>
          <template v-slot:activator >
            <v-list-item-content>
                <v-list-item-title>
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item-content>
          </template>
          <v-list-item
            v-for="(child, i) in item.children"
            :key="i"
            @click="clickTile(child.policy)"
            link
            class="pl-12"
          >
            <v-list-item-action class="mr-2" v-if="child.icon">
              <v-icon size="">{{ child.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ child.title }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-item
          color="primary"
          v-else
          :key="item.text"
          :href="item.href"
          :to="item.link === '#' ? '' : item.link"
          link
        >
          <v-list-item-action class="mr-6">
            <v-icon
              size="24"
              :color="item.color ? item.color : ''"
            >{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title
              link
            >
              {{ item.title }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapState } from 'vuex'

  export default {
    props: {
        source: String,
    },
    data(){
      return {
        policies: [],
        sections: [],
        items: [
          {
            title: 'Getting Started',
            icon: 'mdi-inbox',
            model: false,
            children: [
              { title: 'Overview', icon: 'mdi-circle-small', link: '/documentation/overview' },
              { title: 'Licences', icon: 'mdi-circle-small', link: '/documentation/licences' },
              { title: 'Quick Start', icon: 'mdi-circle-small', link: '/documentation/quick-start' }
            ],
          },
          {
            title: 'Components',
            icon: 'mdi-image-filter-none',
            model: false,
            children: [
              { title: 'Charts', icon: 'mdi-circle-small', link: '/documentation/charts' },
              { title: 'Forms', icon: 'mdi-circle-small', link: '/documentation/forms' },
              { title: 'UI', icon: 'mdi-circle-small', link: '/documentation/ui' },
              { title: 'Maps', icon: 'mdi-circle-small', link: '/documentation/maps' },
              { title: 'Tables', icon: 'mdi-circle-small', link: '/documentation/tables' },
            ],
          },
        ],
        sidebarWidth: 330,
        sidebarMinWidth: 96,
        policytypes: ['Welcome', 'Employment', 'Workplace Behavior', 'Recruitment', 'Health & Safety', 'Leave', 'Benefits', 'Performance', 'Employee Separation', 'Training & Development', 'Business Travel', 'Administration'],
      }
    },
    computed: {
      ...mapState('Layout', {drawer: state => state.drawer}),
      DRAWER_STATE: {
        get() {
          return this.drawer
        },
        set(newValue) {
          if (newValue === this.drawer) return;
          this.TOGGLE_DRAWER();
        }
      }
    },
    methods: {
      ...mapActions('Layout', ['TOGGLE_DRAWER']),
      ...mapActions('MyAccount', ['getMyPoliciesRequest', 'setPolicy']),
      clickTile(item){
        let json = Object.assign({}, item);
        json.details.sort((a,b) =>{
          if (b.detailrank > a.detailrank) return -1;
          if (a.detailrank < b.detailrank) return 1;
          return 0;
        });
        this.setPolicy(json);
      }
    },
    async mounted(){
      this.policies = await this.getMyPoliciesRequest();

      for(var j in this.policytypes){
        let type = this.policytypes[j];
        let filtered_policies = this.policies.filter(policy=>policy.policytype==type);
        if(filtered_policies.length>0){
          let section = {title: type, icon: 'mdi-text-box', model: false, children: []};
          for(var k in filtered_policies){
            let policy = filtered_policies[k];
            section.children.push({ title: policy.policyname, icon: 'mdi-circle-small', link: '/documentation/tables' , policy: policy})
          }
          this.sections.push(section);
        }
      }
      this.setPolicy(this.sections[0].children[0].policy)
    }
  }
</script>

<style src="./DocSidebar.scss" lang="scss"/>
